import { FormularioEnlace, FormularioPassword, NuevaPassword, useAuth } from '@eg/compartido'
import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { es } from '../../content/es'

/** Pantalla para elegir contraseña nueva tras abrir el enlace de «Olvidé mi contraseña». */
export function ElegirPassword() {
  return (
    <>
      <h1 className="titulo-seccion">{es.acceso.nuevaTitulo}</h1>
      <p className="seccion__intro prosa">{es.acceso.nuevaIntro}</p>
      <div className="principal__cuerpo">
        <NuevaPassword />
      </div>
    </>
  )
}

/** Acceso de compradores: correo y contraseña, con crear cuenta y, como alternativa, un enlace al correo. */
export function Ingresar() {
  const { cargando, sesion } = useAuth()
  const [conEnlace, setConEnlace] = useState(false)
  if (sesion) return <Navigate to="/mi-empresa" replace />
  return (
    <>
      <h1 className="titulo-seccion">{es.acceso.titulo}</h1>
      <p className="seccion__intro prosa">{conEnlace ? es.acceso.introEnlace : es.acceso.intro}</p>
      <div className="principal__cuerpo">
        {cargando ? (
          <div role="status" aria-live="polite">
            <p className="seccion__intro">{es.acceso.cargando}</p>
            <div className="esqueleto" />
          </div>
        ) : conEnlace ? (
          <>
            <FormularioEnlace textos={es.acceso} crearCuenta />
            <p className="accion">
              <button type="button" className="boton boton--terciario boton--compacto" onClick={() => setConEnlace(false)}>
                {es.acceso.usarPassword}
              </button>
            </p>
          </>
        ) : (
          <>
            <FormularioPassword permitirRegistro />
            <p className="accion">
              <button type="button" className="boton boton--terciario boton--compacto" onClick={() => setConEnlace(true)}>
                {es.acceso.usarEnlace}
              </button>
            </p>
          </>
        )}
      </div>
    </>
  )
}
